import { render, staticRenderFns } from "./Evidences.vue?vue&type=template&id=b089e9d2&scoped=true&"
import script from "./Evidences.vue?vue&type=script&lang=js&"
export * from "./Evidences.vue?vue&type=script&lang=js&"
import style0 from "./Evidences.vue?vue&type=style&index=0&id=b089e9d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b089e9d2",
  null
  
)

export default component.exports